export const ACCEPTED_FILE_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
  'image/png',
  'image/jpeg',
];

export const ACCEPTED_FILE_TYPES_COMMUNITY: string[] = ['application/pdf', 'image/png', 'image/jpeg'];

export const ACCEPTED_DROPZONE_FILE_TYPES = ACCEPTED_FILE_TYPES.reduce<{ [key: string]: [] }>(
  (acc, fileType) => {
    acc[fileType] = [];
    return acc;
  },
  {},
);

export const ACCEPTED_CHAT_FILE_TYPES = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf',
  'image/png',
  'image/jpeg',
  'text/plain',
  '.csv',
];

export const ACCEPTED_CHAT_FILE_TYPES_STRING = ACCEPTED_CHAT_FILE_TYPES.join(', ');
